import { isAxiosError } from 'axios'

export const isValidationFailure = (error: unknown): boolean => {
	if (!isAxiosError(error) || error.response?.status !== 422) {
		return false
	}
	const data: unknown = error.response.data
	if (typeof data !== 'object' || data === null || 'error' in data) {
		return false
	}
	return 'errors' in data && typeof data.errors === 'object' && data.errors !== null && !Array.isArray(data.errors)
}
